import * as React from "react";
import { forwardRef } from "react";
const SvgZoomOut = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	height: "1em",
	viewBox: "0 0 12 12",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M5.41025 9.82049C7.84596 9.82049 9.82049 7.84596 9.82049 5.41025C9.82049 2.97453 7.84596 1 5.41025 1C2.97453 1 1 2.97453 1 5.41025C1 7.84596 2.97453 9.82049 5.41025 9.82049Z",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M3.75635 5.41016H7.06403",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M8.66309 8.7868L10.8563 10.8561",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgZoomOut);
export default ForwardRef;
